export default "__VITE_ASSET__8ecf8c85__"